import { render } from "./VoucherPurchaseTab.vue?vue&type=template&id=6213336c&scoped=true"
import script from "./VoucherPurchaseTab.vue?vue&type=script&lang=js"
export * from "./VoucherPurchaseTab.vue?vue&type=script&lang=js"

import "./VoucherPurchaseTab.vue?vue&type=style&index=0&id=6213336c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6213336c"]])

export default __exports__